'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import Alert from 'react-bootstrap/Alert';

/**
 * Displays course messages.
 */
const CourseMessages = (props) => {

    function createMarkup(html) {
        return {__html: html};
    }

    let component = null;
    if (props.messages && props.messages.length) {
        /**
         * The icon color would be info, but bootstrap does an odd color change for alerts vs the given
         * color code in the overrides.
         */
        component =
            <Alert variant="info" className="border-0 bg-transparent d-inline-flex align-items-start mt-3">
                <dl dangerouslySetInnerHTML={createMarkup(props.messages)}/>
            </Alert>;
    }

    return component;
};

CourseMessages.propTypes = {
    messages: PropTypes.string.isRequired
};

export default CourseMessages;